import { useMemo } from 'react';
import { useTranslation } from '../../../contexts/translation-context';
import { useConfig } from '../../../contexts/config-context';
import { getCallingCode } from './phone-input-utils';
import { isSupportedCountry } from 'libphonenumber-js';
import { COUNTRY_CODES } from '@wix/form-multiline-address';
const MISSING_FLAGS = ['ABW', 'ANT', 'ATA', 'BVT', 'CCK', 'COK', 'CXR', 'CYP', 'ESH', 'GUF', 'HMD', 'MUS', 'SWZ', 'UMI'];
export function useCountries(searchPhrase) {
  const {
    t
  } = useTranslation();
  const {
    locale
  } = useConfig();
  const countries = useMemo(() => {
    return Object.keys(COUNTRY_CODES).reduce((result, shortCountryCode) => {
      const longCountryCode = COUNTRY_CODES[shortCountryCode];
      const callingCode = getCallingCode(longCountryCode);
      const hasFlag = !MISSING_FLAGS.includes(longCountryCode);
      const countryName = t(`locale-dataset.countries.${longCountryCode.toUpperCase()}`);
      if (callingCode && hasFlag && isSupportedCountry(shortCountryCode)) {
        result.push({
          countryName,
          longCountryCode,
          shortCountryCode,
          callingCode
        });
      }
      return result;
    }, []).sort((a, b) => a.countryName.localeCompare(b.countryName, locale));
  }, [t, locale]);
  const matchingCountries = useMemo(() => countries.filter(country => isCountryMatching(country, searchPhrase), []), [countries, searchPhrase]);
  return matchingCountries;
}
function isCountryMatching(country, searchPhrase) {
  const {
    countryName,
    callingCode,
    shortCountryCode
  } = country;
  if (isSubstring(countryName, searchPhrase)) {
    return true;
  }
  if (isSubstring(callingCode, searchPhrase)) {
    return true;
  }
  if (isSubstring(shortCountryCode, searchPhrase)) {
    return true;
  }
  return false;
}
function isSubstring(full, part) {
  return full.toLowerCase().includes(part.toLowerCase());
}
//# sourceMappingURL=use-countries.js.map